/* eslint-disable @typescript-eslint/member-ordering */
  import { AfterViewChecked, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild, ViewContainerRef } from '@angular/core';
  import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
  import { FidelityService } from '../../../fidelity/fidelity.service';
  import { AgentsService } from '../../../agents/agents.service';
  import { UserService } from '../../../pages/com.usblick.common/auth/user.service';
  import { ICreateOrderRequest, IPayPalConfig } from 'ngx-paypal';
  import { RestService } from '../../rest.service';

  import { NgxSpinnerService } from 'ngx-spinner';
  import { setting } from '../../../../../setting';
  import { ItineraryService } from 'app/shared/itinerary.service';
  import { animate, state, style, transition, trigger } from '@angular/animations';
  import { SquareStrategy } from 'services/payments/strategies/square.strategy';
  import { PaymentsService } from 'services/payments/payments.service';
  import { SquareService } from 'services/payments/services/square.service';
  import { PaymentResult } from 'services/payments/payment-strategy.interface';
import { PaypalStrategy } from 'services/payments/strategies/paypal.strategy';
import { MercadoPagoStrategy } from 'services/payments/strategies/mercado-pago.strategy';
import { MercadoPagoService } from 'services/payments/services/mercado-pago.service';
import { NotificationService } from 'app/shared/notifications/notification.service';

/** Fee bancario estimado de un método de pago (informativo; lo registra el backend). */
export interface BankFeeRow {
  methodId: number;
  label: string;
  amount: number;
  percentage: number;
  surcharge: number;
  total: number;
}

/** Comprobantes de transferencia admitidos: extensión → MIME que debe coincidir con la firma real */
const VOUCHER_EXTENSIONS: { [extension: string]: string } = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  pdf: 'application/pdf'
};


  @Component({
    selector: 'usb-payment-items',
    templateUrl: './payment-items.component.html',
    styleUrls: ['./payment-items.component.scss'],
    animations: [
      trigger('slideInOut', [
        state('in', style({
          height: '*',
          opacity: 1
        })),
        state('out', style({
          height: '0px',
          opacity: 0
        })),
        transition('in <=> out', [
          animate('900ms ease-in-out')
        ])
      ])
    ],
    providers: [
                  SquareService,
                  SquareStrategy,
                  PaypalStrategy,
                  MercadoPagoStrategy,
                  PaymentsService
              ]
  })
  export class PaymentItemsComponent implements OnInit, AfterViewChecked, OnChanges, OnDestroy {

    public payPalConfig?: IPayPalConfig;

    @Input() items: any;
    @Input() itinerary: any;
    // Valor recibido del padre. Se copia a `totalPrice` una sola vez en ngOnInit:
    // este componente convierte totalPrice a otra moneda (ver changeCurrencyPayment),
    // y si siguiéramos leyendo el Input directamente, cualquier cambio posterior del
    // padre (p. ej. this.totalPrice += fee en applyFee()) pisaría esa conversión.
    @Input() totalPriceInput: any;
    @Input() paymentMethodsArr: any[] = [];
    @Input() creditCardPending: boolean = false;
    @Input() creditCardDataPending: any[] = [];
    @Input() creditCardPayPartial: boolean = false;
    @Input() currencyItinerary: string;
    @Input() itineraryItems: any[] = [];
    @Input() currencies: any[] = [];
    @Input() paymentConditions: any[];
    @Input() currencyAgency: any;
    @Input() fee: number = 0;
    // Recargos por forma de pago de la agencia ({ payment_methods, payment_platforms }).
    // Fase 1: solo se muestran como estimación; no modifican montos cobrados ni el payload.
    @Input() paymentFees: any = null;
    @Input() getClientsSettingAppBooking: any;
    @Output() leaveTotal = new EventEmitter<any>();
    @Output() applyFeeEmitter = new EventEmitter<boolean>(false);
    @Output() paymentCardWithApplyFeeEmitter = new EventEmitter<boolean>(false);
    @Output() emitFeePayment = new EventEmitter<number>();
    @Output() currencyPaymentEmmiter = new EventEmitter<any>();
    @Output() totalPriceEmit = new EventEmitter();
    @Output() guestPaymentDone = new EventEmitter<void>();

    @ViewChild("inputPoints") inputPoints: HTMLInputElement;
    @ViewChild("inputCredits") inputCredits: HTMLInputElement;
    @ViewChild("inputTranfer") inputTranfer: HTMLInputElement;
    @ViewChild("inputCard") inputCard: HTMLInputElement;

    @ViewChild('squareContainer', { static: false }) squareContainer!: ElementRef;

    @ViewChild("icons-caret") iconsCaret: ElementRef;

    agency: any;
    maxDateAdult: any;

    isPointsSelected: boolean = false;
    isDepositSelected: boolean = false;
    isTranferSelected: boolean = false;
    isCardSelected: boolean = false;
    isCreditSelected: boolean = false;
    // Id del método cuyo panel está expandido (1 Blickoins, 2 Tarjeta, 3 Depósito, 4 Transferencia; 0 = ninguno).
    // Es independiente de isXSelected: permite cerrar el acordeón de un método sin desactivarlo.
    openMethodId: number = 0;
    isSelectModePay: boolean = false;
    onApprove: boolean = false;
    amountPoints: any = null;
    amountDeposit: any = null;
    amountTranfer: any = null;
    amountCard: any = null;
    amountCredit: any = null;

    errorPoints: boolean = false;
    errorDeposit: boolean = false;
    errorTranfer: boolean = true;
    errorCard: boolean = true;
    errorCredit: boolean = false;
    // Se activa cuando la suma de todos los métodos activos supera el total a pagar
    // (posible al combinar dos o más métodos a la vez)
    errorOverpay = false;
    totalPayCreditCard: boolean = false;

    creditBlickoinsActives: any = 0;
    creditDepositActives: any = 0;
    creditsActives: any = 0;

    leftTotal: any = 0;
    totalPrice: any;


    filesArray: any = [];
    fileName: any = null;
    payload:  any = [];
    payloadDetails:  any = [];
    dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
    filter: any = '';

    currentPage: number = 1;
    paymentMethods: any = [];
    paymentCreditCards: any = [];


    totalPaymentCreditCards: any = 0;
    // Variable de almacenamiento de monto pendiente de pagos con tarjeta de credito pendiente
    amountCreditCard: number = 0;
    amountCreditCardPayPartial: any = 0;
    partialLeft: number = 0;

    public errorImageDimension: boolean = false;
    public errorImageSize: boolean = false;
    public errorImageFormat: boolean = false;

    public blickoinsPay: boolean = false;
    public creditCardPay: boolean = false;
    public creditDepositPay: boolean = false;
    public transferPay: boolean = false;
    public creditPay: boolean = false;
    public cardPayment: boolean = false;
    applyFee: boolean = false;
    feeVisible: boolean = true;
    currencyPayment: string = '';
    paymentAgencyActive: any[] = [];
    selectedMethodPlatformPayment: string = '';
    isSquareReady: boolean = false;
    isProcessing: boolean = false;

    // square inicializar
      private squareInitializationAttempted = false;
    private squareInitialized = false;

    // Mercado Pago (tarjeta en ARS)
    readonly mercadoPagoContainerId = 'mercadopago-card-container';
    isMercadoPagoReady = false;
    // Importe con el que está renderizado el formulario (las cuotas dependen de él)
    private mercadoPagoRenderedAmount: number | null = null;
    private mercadoPagoRenderTimeout: any = null;

    constructor(
      public fidelityService: FidelityService,
      public vcr: ViewContainerRef,
      public agentsService: AgentsService,
      public userService: UserService,
      private _restService: RestService,
      public ngSpinner: NgxSpinnerService,
      private itineraryService: ItineraryService,
      private notificationService: NotificationService,
      private paymentsService: PaymentsService,
      private paypalStrategy: PaypalStrategy,
      private squareStrategy: SquareStrategy,
      private squareService: SquareService,
      private mercadoPagoStrategy: MercadoPagoStrategy,
      private mercadoPagoService: MercadoPagoService,
      private cdr: ChangeDetectorRef
    ) {
      this.dpConfig.containerClass = 'theme-red';
    }

    ngOnDestroy(): void {
      clearTimeout(this.mercadoPagoRenderTimeout);
      this.mercadoPagoService.destroyCardForm();
    }
    ngAfterViewChecked(): void {
      this.checkAndInitializeSquare();
    }

    ngOnChanges(changes: SimpleChanges): void {
      // Los porcentajes llegan de forma asíncrona desde el padre: recalcular el fee bancario
      // informativo cuando estén disponibles (si el componente ya estaba inicializado).
      if (changes['paymentFees'] && !changes['paymentFees'].firstChange) {
        this.calculateLeftTotal();
      }
    }


  ngOnInit() {
    // Copia única del Input: a partir de acá `totalPrice` es propio de este componente
    // (ver comentario en la declaración de totalPriceInput más arriba).
    this.totalPrice = this.totalPriceInput;
    this.currencyPayment = this.currencyAgency?.code;

    this.agency = JSON.parse(localStorage.getItem('selectedAgency'));
    this.initConfig();
    if(!this.agency) {
      this.notificationService.warning('No hay información de la agencia');
      return;
    }
    this.availablePaymentConditions(this.paymentConditions);
   // this.filter  =  'itinerary_id=' + this.items[0].itinerary_id + '&&payment_masters_id=0';
   if(!this.creditCardPending && this.creditCardPayPartial) {
     this.isCardSelected = true;
     this.openMethodId = 2;
    this.verifyPaymentMethod(2);

       if(this.isCardSelected) {

         this.filter  =  'itinerary_id=' + this.creditCardDataPending[0].itinerary_id;
         let creditCardPartialNull = this.creditCardDataPending.filter(c => c.payment_masters_id === null);

        // Crear un conjunto para almacenar los IDs de los elementos en creditCardPartialNull
        const paymentIds = new Set<number>();
        creditCardPartialNull.forEach(payment => {
            paymentIds.add(Number(payment.details[0].uid));
        });

        // Sumar los valores solo para los elementos en this.itineraryItems que tienen un ID coincidente en paymentIds
        this.itineraryItems.forEach(item => {
            if (paymentIds.has(item.id)) {

                this.partialLeft += item.optionNightsNetTotalProf;
            }
        });

        //  this.paymentMethods = creditCardPartialNull
         this.amountCreditCardPayPartial = this.amountSumCreditCardPending(creditCardPartialNull);
         this.totalPrice = this.partialLeft;
        }
   }
   if(this.creditCardDataPending.length > 0 && !this.creditCardPayPartial) {
     this.isCardSelected = true;
     this.openMethodId = 2;
    this.verifyPaymentMethod(2);
    if(this.isCardSelected) {
         this.filter  =  'itinerary_id=' + this.creditCardDataPending[0].itinerary_id;
         this.amountCreditCard = this.amountSumCreditCardPending(this.creditCardDataPending);
         this.currencyPayment = 'USD';
    }


   } if(!this.creditCardPending && !this.creditCardPayPartial) {
     this.filter  =  'itinerary_id=' + this.items[0].itinerary_id;
   }

    if (this.userService.balanceBlickoins > 0) {
      this.creditBlickoinsActives = this.userService.creditBlickoins;
    }


    this.creditDepositActives = this.userService.creditsDeposits;
    this.creditsActives = this.userService.credits;
    this.totalPrice = Math.round(this.totalPrice * 100) / 100;
    this.leftTotal = this.totalPrice;

    this.getPaymentCreditCards(this.filter);
    this.loadMercadoPagoConfig();

    if (this.userService._isGuest) {
      // Guest: pago único con tarjeta por el total, sin combinar métodos.
      // Todo el circuito de tarjeta acá asume USD, y totalPrice llega en la
      // moneda de la agencia (setPriceTotal() del modal) — se reutiliza
      // changeCurrencyPayment('USD'), que ya sabe convertir totalPrice y
      // resetea las selecciones, para no duplicar esa conversión a mano.
      this.selectedMethodPlatformPayment = 'square';
      this.changeCurrencyPayment('USD');
      this.isCardSelected = true;
      this.openMethodId = 2;
      this.amountCard = this.totalPrice;
      this.calculateLeftTotal();
    }

  }

  // ─── Recargos por forma de pago (fase 1: estimación, sin cambiar cobros ni payload) ───
  // Ids internos del componente: 1 Blickoins, 2 Tarjeta, 3 Depósito, 4 Transferencia, 5 Cuenta corriente.
  // Coinciden con payment_method_id de la API; la tarjeta no tiene recargo propio: depende de la
  // plataforma elegida (payment_platforms). El recargo se calcula sobre lo que cada método cancela
  // de la tarifa neta: Σ montos = tarifa neta (multipago) y el total a pagar = tarifa neta + Σ recargos.

  private readonly platformLabels: { [name: string]: string } = {
    paypal: 'PayPal',
    square: 'Square',
    mercadopago: 'Mercado Pago',
  };

  /**
   * Plataformas de tarjeta que se ofrecen en pantalla.
   * USD: Square / PayPal (los invitados pagan con Square). ARS: solo Mercado Pago, si la agencia lo tiene.
   */
  private getAvailableCardPlatforms(): string[] {
    if (this.userService._isGuest) {
      return ['square'];
    }
    if (this.currencyPayment !== 'USD') {
      return this.isMercadoPagoEnabled() ? ['mercadopago'] : [];
    }
    return ['paypal'];
  }

  /** "Mercado Pago" / "mercadopago" / "MercadoPago" → "mercadopago" */
  private normalizePlatformName(name: string): string {
    return (name || '').toLowerCase().replace(/[\s_-]/g, '');
  }

  getPlatformFeePercentage(platformName: string): number {
    const name = this.normalizePlatformName(platformName);
    const platform = name === 'mercadopago'
      ? this.getMercadoPagoPlatform()
      : this.paymentFees?.payment_platforms?.find((p: any) => this.normalizePlatformName(p.name) === name);
    return Number(platform?.fee_percentage) || 0;
  }

  /**
   * Mercado Pago se ofrece si: la moneda de pago es la de liquidación (ARS), la agencia tiene
   * la plataforma configurada (payment_platforms de agencies/{id}/payment-fees) y hay clave
   * pública. No aplica a invitados: pay-reservate solo cobra con Square.
   */
  isMercadoPagoEnabled(): boolean {
    if (this.userService._isGuest || this.currencyPayment !== MercadoPagoStrategy.CURRENCY) {
      return false;
    }
    if (!this.mercadoPagoService.isConfigured()) {
      return false;
    }
    return !!this.getMercadoPagoPlatform();
  }

  /**
   * Pide la clave pública de Mercado Pago al backend (get-cards/{client}, con el cliente del
   * itinerario). Hasta que llega, isMercadoPagoEnabled() da false y el botón no se muestra.
   */
  private loadMercadoPagoConfig(): void {
    if (this.userService._isGuest) {
      return;
    }
    const clientId = Number(this.itinerary?.client_id ?? this.itinerary?.clients?.id ?? this.itinerary?.clientId);
    if (!clientId) {
      return;
    }

    this.mercadoPagoService.loadConfig(clientId).then(() => this.cdr.markForCheck());
  }

  /** Plataforma Mercado Pago de la agencia: por payment_platform_id (2) o, si no viene, por nombre ("mercadoPago") */
  private getMercadoPagoPlatform(): any {
    const platforms = this.paymentFees?.payment_platforms || [];
    return platforms.find((p: any) => Number(p.payment_platform_id) === MercadoPagoStrategy.PLATFORM_ID)
      || platforms.find((p: any) => this.normalizePlatformName(p.name) === 'mercadopago');
  }

  getMethodFeePercentage(methodId: number): number {
    if (methodId === 2) {
      return this.selectedMethodPlatformPayment ? this.getPlatformFeePercentage(this.selectedMethodPlatformPayment) : 0;
    }
    const method = this.paymentFees?.payment_methods?.find((m: any) => Number(m.payment_method_id) === methodId);
    return Number(method?.fee_percentage) || 0;
  }

  /** Badge de la fila de tarjeta: % de la plataforma elegida o, sin elegir, el menor disponible. */
  getCardFeeBadge(): string {
    if (this.selectedMethodPlatformPayment) {
      const pct = this.getPlatformFeePercentage(this.selectedMethodPlatformPayment);
      return pct > 0 ? `+${pct}%` : '';
    }
    const percentages = this.getAvailableCardPlatforms().map(p => this.getPlatformFeePercentage(p));
    const min = Math.min(...percentages);
    const max = Math.max(...percentages);
    if (max <= 0) {
      return '';
    }
    return min === max ? `+${min}%` : `desde +${min}%`;
  }

  /** Lo que el método cancela de la tarifa neta. Tarjeta: pagos ya registrados + monto a cobrar. */
  getMethodNetAmount(methodId: number): number {
    switch (methodId) {
      case 1: return Number(this.amountPoints) || 0;
      case 2: return (Number(this.amountCard) || 0) + (Number(this.totalPaymentCreditCards) || 0);
      case 3: return Number(this.amountDeposit) || 0;
      case 4: return Number(this.amountTranfer) || 0;
      case 5: return Number(this.amountCredit) || 0;
      default: return 0;
    }
  }

  getMethodSurcharge(methodId: number, amount: number = this.getMethodNetAmount(methodId)): number {
    const surcharge = (Number(amount) || 0) * this.getMethodFeePercentage(methodId) / 100;
    return Math.round(surcharge * 100) / 100;
  }

  /** Hay algún recargo configurado (> 0) para la agencia. */
  hasPaymentFees(): boolean {
    const methods = this.paymentFees?.payment_methods || [];
    const platforms = this.paymentFees?.payment_platforms || [];
    return [...methods, ...platforms].some((fee: any) => Number(fee.fee_percentage) > 0);
  }

  private isMethodActive(methodId: number): boolean {
    return methodId === 5 ? this.isCreditSelected : this.isMethodSelected(methodId);
  }

  /** Filas del resumen del multipago: método, lo que cancela, recargo y total con recargo. */
  getFeeSummaryRows(): BankFeeRow[] {
    return [1, 3, 4, 2, 5]
      .filter(id => this.isMethodActive(id) && this.getMethodNetAmount(id) > 0)
      .map(id => {
        const amount = this.getMethodNetAmount(id);
        const surcharge = this.getMethodSurcharge(id, amount);
        return {
          methodId: id,
          label: this.getMethodLabel(id),
          amount,
          percentage: this.getMethodFeePercentage(id),
          surcharge,
          total: Math.round((amount + surcharge) * 100) / 100,
        };
      });
  }

  getPlatformLabel(platformName: string): string {
    return this.platformLabels[(platformName || '').toLowerCase()] || platformName;
  }

  private getMethodLabel(methodId: number): string {
    switch (methodId) {
      case 1: return 'Blickoins';
      case 2: return this.selectedMethodPlatformPayment
        ? `Tarjeta (${this.getPlatformLabel(this.selectedMethodPlatformPayment)})`
        : 'Tarjeta';
      case 3: return 'Depósito';
      case 4: return 'Transferencia';
      case 5: return 'Cuenta corriente';
      default: return '';
    }
  }

  getFeeSummaryTotals(): { amount: number; surcharge: number; total: number } {
    return this.getFeeSummaryRows().reduce(
      (totals, row) => ({
        amount: Math.round((totals.amount + row.amount) * 100) / 100,
        surcharge: Math.round((totals.surcharge + row.surcharge) * 100) / 100,
        total: Math.round((totals.total + row.total) * 100) / 100,
      }),
      { amount: 0, surcharge: 0, total: 0 }
    );
  }

  // Click en la fila de un método. Si todavía no estaba activo, lo activa
  // (comportamiento histórico: clic en la fila = seleccionar y abrir). Si ya
  // estaba activo, solo alterna si su panel está abierto o cerrado, sin tocar
  // su checkbox ni su monto: así abrir otro método no desconfigura este.
  toggleOpenPanel(id: number): void {
    if (!this.isMethodSelected(id)) {
      this.activateMethod(id);
      return;
    }
    this.openMethodId = this.openMethodId === id ? 0 : id;
  }

  private isMethodSelected(id: number): boolean {
    switch (id) {
      case 1: return this.isPointsSelected;
      case 2: return this.isCardSelected;
      case 3: return this.isDepositSelected;
      case 4: return this.isTranferSelected;
      default: return false;
    }
  }

  private activateMethod(id: number): void {
    switch (id) {
      case 1: this.pointsChange(); break;
      case 2: this.cardChange(); break;
      case 3: this.creditChange(); break;
      case 4: this.tranferChange(); break;
    }
  }

  // amountCard y totalPrice suben juntos en addFee() (ver comentario ahí), así que
  // hay que bajarlos juntos acá también para no dejar el fee "pegado" en totalPrice.
  private revertFeeIfApplied(): void {
    if (this.applyFee) {
      this.amountCard = parseFloat((this.amountCard - this.fee).toFixed(2));
      this.totalPrice = parseFloat((this.totalPrice - this.fee).toFixed(2));
      this.applyFee = false;
      this.applyFeeEmitter.emit(false);
      // Sincroniza el TOTAL que muestra el padre (totalPaymentPrice), que solo se
      // actualiza escuchando este evento.
      this.totalPriceEmit.emit(this.totalPrice);
    }
  }

  private amountSumCreditCardPending(paymentCreditCards: any) {
    let amount: number = 0;
     // Recorrer el array de paymentCreditCards con el fin de sumar los montos de amount para el monto total
      // de pagos pendientes
    paymentCreditCards.forEach((payment: any) => {
      amount += payment.amount;

    });

    return amount;
  }

  // getPaymentConditions(page: number) {
  //   const goPage = (page > 1) ? 'page=' + page : '';
  //   const url = 'agencyPaymentCondition/list?' + goPage;
  //   this._restService.doGet('app', url).subscribe({
  //     next: (response: any) => {
  //       this.paymentConditions = response;
  //       this.availablePaymentConditions(this.paymentConditions);
  //     },
  //     error: (error: HttpErrorResponse) => {
  //       console.log('No existe informacion, Condición de Pagos!', error);
  //     }
  //   })
  // }

  // Habilitar los métodos de pago activdos en la agencia
  private availablePaymentConditions(dataPaymentCondition: any) {
    const payAgencyActive = dataPaymentCondition.find(c => c.id === this.agency.pay_mode);
    this.paymentAgencyActive = payAgencyActive;
    payAgencyActive.payment_methods_conditions.forEach(payment => {
      if(this.creditCardDataPending.length === 0 || this.creditCardPayPartial) {
        this.blickoinsPay = this.blickoinsPay || payment.payment_methods_id === 1;
        this.creditCardPay = this.creditCardPay || payment.payment_methods_id === 2;
        this.creditDepositPay = this.creditDepositPay || payment.payment_methods_id === 3;
        this.transferPay = this.transferPay || payment.payment_methods_id === 4;
        this.creditPay = this.creditPay || payment.payment_methods_id === 5;
      }
      if(this.creditCardDataPending.length > 0 && !this.creditCardPayPartial) {
        this.creditCardPay = this.creditCardPay || payment.payment_methods_id === 2;
      }
    });
  }

  calculateLeftTotal() {
    setTimeout(() => {

      // this.paymentMethods = [];
      let aux: number;
      aux = this.totalPrice;

    if (this.amountPoints > 0) {
      aux -= this.amountPoints;

      //validacion de errores
      if (this.currencyPayment === 'USD' && ((this.amountPoints > this.creditBlickoinsActives) || (this.amountPoints > this.totalPrice) || (this.amountPoints < 0))) {
        this.errorPoints = true;
      }
      else if(this.currencyPayment !== 'USD' && (((this.amountPoints / this.currencyAgency.rate) > this.creditBlickoinsActives) || ((this.amountPoints / this.currencyAgency.rate) > this.totalPrice) || ((this.amountPoints / this.currencyAgency.rate) < 0))) {
          this.errorPoints = true;
      }
      else {
        this.errorPoints = false;
      }
    }
    if (this.amountDeposit > 0) {
        aux -= this.amountDeposit;


       //validacion de errores
       if ((this.amountDeposit > this.creditDepositActives) || (this.amountDeposit > this.totalPrice) || (this.amountDeposit < 0)) {
        this.errorDeposit = true;
      } else {
        this.errorDeposit = false;
      }
    }
    if (this.amountTranfer > 0) {
      aux -= this.amountTranfer;

        //validacion de errores
      if (this.amountTranfer < 0 || this.fileName == null) {
        this.errorTranfer = true;
      } else {
        this.errorTranfer = false;
      }
    }
    if (this.amountCard > 0 || this.isCardSelected) {
      aux -= this.amountCard;

      // validacion de errores  // ||  this.leftTotal > 0
       if (this.amountCard < 0  || this.totalPaymentCreditCards == 0) {
        this.errorCard = true;
      } else {
        this.errorCard = false;
      }
      if(this.totalPaymentCreditCards === this.totalPrice) {
        this.errorCard = false;
      }
    }
    if (this.isCreditSelected) {
      aux -= this.amountCredit;

      //validacion de errores
      if ((this.amountCredit > this.creditsActives) || (this.amountCredit > this.totalPrice) || (this.amountCredit < 0)) {
        this.errorCredit = true;
      } else {
        this.errorCredit = false;
      }
    }

        // Si aux es negativo, la suma de los métodos activos supera el total a pagar
        // (se tolera un pequeño margen por redondeo de decimales)
        this.errorOverpay = aux < -0.01;

        // Validamos si aux es menor que cero, lo que significa que el monto total restante sería negativo
        if (aux < 0) {
          aux = 0; // Si es así, lo establecemos como cero para evitar valores negativos
      }
    // Actualiza la información de paymentMethods
    this.updatePaymentMethods();

    this.leftTotal = aux.toFixed(2);


    if (this.leftTotal == -0.00) {
      this.leftTotal = 0;
    }


    if  (this.totalPaymentCreditCards > 0)   {  // se descuemta los pagos por TDC
        this.leftTotal =  this.leftTotal - this.totalPaymentCreditCards;
        if(this.leftTotal === 0 && !this.creditCardPayPartial) {
          this.totalPayCreditCard = true;
        }
      }


    let data: any = {};


    if(this.creditCardDataPending.length > 0 && !this.creditCardPayPartial) {
      data = {
        aux: 0,
        paymentMethods: this.paymentMethods
      }
    }
    if(this.creditCardDataPending.length > 0 && this.creditCardPayPartial) {

      data = {
        aux: parseFloat(this.leftTotal),
        paymentMethods: this.paymentMethods
      }
    }
      if(this.creditCardDataPending.length === 0) {
        data = {
          aux: parseFloat(this.leftTotal),
          paymentMethods: this.paymentMethods
        };
      }

    // Fee bancario informativo para el padre (MONTO TRANSACCIÓN y modal de confirmación).
    // Va aparte de paymentMethods a propósito: el backend calcula y registra el fee por su
    // cuenta, así que no tiene que viajar en el payload de pagos.
    data.bankFees = {
      rows: this.getFeeSummaryRows(),
      totals: this.getFeeSummaryTotals(),
    };

    this.leaveTotal.emit(data);

    // Las cuotas del formulario de Mercado Pago dependen del importe: re-renderizar si cambió
    this.scheduleMercadoPagoRender();
    }, 0);
  }

  private updatePaymentMethods() {
    if (this.isPointsSelected) {
      this.updatePaymentMethod(1, this.amountPoints, this.errorPoints || this.errorOverpay);
    } else {
      this.removePaymentMethod(1);
    }

    // Si hay pagos con depósito
    if (this.isDepositSelected) {
      this.updatePaymentMethod(3, this.amountDeposit, this.errorDeposit || this.errorOverpay);
    } else {
      this.removePaymentMethod(3);
    }

    // Si hay pagos con transferencia
    if (this.isTranferSelected) {
      this.updatePaymentMethod(4, this.amountTranfer, this.errorTranfer || this.errorOverpay);
    } else {
      this.removePaymentMethod(4);
    }

    // Si hay pagos con tarjeta de crédito
    if (this.isCardSelected) {
      if(this.creditCardDataPending.length > 0 && !this.creditCardPayPartial) {
        this.errorCard = false;
        this.amountCard = this.creditCardDataPending[0].amount;
        if(this.leftTotal === 0) {
          this.creditCardPending = true;
        }
        this.updatePaymentMethod(2, this.amountCard, this.errorCard || this.errorOverpay);
      }
      if(this.creditCardDataPending.length > 0 && this.creditCardPayPartial) {
        this.errorCard = this.amountCard > 0 ? true : false;
        const amountCard = this.totalPaymentCreditCards
        this.updatePaymentMethod(2, amountCard, this.errorCard || this.errorOverpay);
      }
      if(this.creditCardDataPending.length === 0) {
        const amountCard = this.totalPaymentCreditCards;
        this.updatePaymentMethod(2, amountCard, this.errorCard || this.errorOverpay);
      }
    } else {
      this.removePaymentMethod(2);
    }

    // Si hay pagos con crédito
    if (this.isCreditSelected) {
      this.updatePaymentMethod(5, this.amountCredit, this.errorCredit || this.errorOverpay);
    } else {
      this.removePaymentMethod(5);
    }
  }

  // Elimina la entrada de un método de pago deseleccionado para que no quede
  // "huérfana" bloqueando la validación del botón Continuar en el componente padre
  private removePaymentMethod(id: number) {
    const itemFound = this.paymentMethods.find(element => element.id == id);
    if (itemFound) {
      const index = this.paymentMethods.indexOf(itemFound);
      if (index > -1) {
        this.paymentMethods.splice(index, 1);
      }
    }
  }

  private updatePaymentMethod(id: number, amount: number, error: boolean) {
    // Método para actualizar un método de pago en la lista paymentMethods
    let itemFound = this.paymentMethods.find(element => element.id == id);
      if (itemFound) {
        let index = this.paymentMethods.indexOf(itemFound);
        if (index > -1) {
          this.paymentMethods.splice(index, 1);
          if(id === 4) {
            this.paymentMethods.push({
              id: id,
              amount: amount,
              error: error,
              filesArray: this.filesArray
            });
          } else {
            this.paymentMethods.push({
              id: id,
              amount: amount,
              error: error
            });
          }
        }
      } else {
        if(id === 4) {
          this.paymentMethods.push({
            id: id,
            amount: amount,
            error: error,
            filesArray: this.filesArray
          });
        } else {
          this.paymentMethods.push({
            id: id,
            amount: amount,
            error: error
          });
        }
      }
  }

  /**
   * Carga de comprobante de transferencia (JPG, PNG o PDF, máx. 2 MB).
   *
   * Seguridad (este flujo también queda expuesto en B2C):
   * - No se confía en la extensión ni en file.type (los define el usuario / el SO): se valida
   *   la firma real del archivo (magic bytes) y debe coincidir con la extensión.
   * - El data URL se arma con el MIME detectado, nunca con el informado por el navegador.
   * - PDF: se rechazan los que contienen contenido activo (JavaScript, acciones automáticas,
   *   archivos embebidos, XFA). Es un filtro heurístico del front: el backend debe volver a
   *   validar tipo, tamaño y contenido.
   * - Los PDF no se renderizan en la vista previa (solo ícono + nombre).
   */
  addPhoto(event) {
    this.errorImageDimension = false;
    this.errorImageFormat = false;
    this.errorImageSize = false;
    this.errorTranfer = false;

    const input = event.target as HTMLInputElement;
    const file: File = input?.files?.[0];
    // Permitir volver a elegir el mismo archivo después de un error o de quitarlo
    if (input) {
      input.value = '';
    }
    if (!file) {
      return;
    }

    const maxSize = 2 * 1024 * 1024; // 2 MB

    if (file.size === 0 || file.size > maxSize) {
      this.rejectVoucher('size');
      return;
    }

    const extension = (file.name.split('.').pop() || '').toLowerCase();
    const extensionType = VOUCHER_EXTENSIONS[extension];
    if (!extensionType) {
      this.rejectVoucher('format');
      return;
    }

    const reader = new FileReader();
    reader.onerror = () => this.rejectVoucher('format');
    reader.onload = () => {
      const bytes = new Uint8Array(reader.result as ArrayBuffer);
      const detectedType = this.detectVoucherType(bytes);

      // La firma tiene que coincidir con la extensión (evita p. ej. un .html renombrado a .pdf)
      if (!detectedType || detectedType !== extensionType) {
        this.rejectVoucher('format');
        return;
      }

      if (detectedType === 'application/pdf' && this.pdfHasActiveContent(bytes)) {
        this.rejectVoucher('format');
        return;
      }

      const dataUrl = `data:${detectedType};base64,${this.bytesToBase64(bytes)}`;

      if (detectedType === 'application/pdf') {
        this.acceptVoucher(file, dataUrl, true);
        return;
      }

      this.validateImageDimensions(dataUrl, () => this.acceptVoucher(file, dataUrl, false));
    };
    reader.readAsArrayBuffer(file);
  }

  /** Imágenes: se mantiene el límite de 1400 x 2100 px */
  private validateImageDimensions(dataUrl: string, onValid: () => void): void {
    const maxWidth = 1400; // Ancho máximo en píxeles
    const maxHeight = 2100; // Alto máximo en píxeles
    const img = new Image();

    img.onload = () => {
      if (img.width <= maxWidth && img.height <= maxHeight) {
        onValid();
      } else {
        this.rejectVoucher('dimension');
      }
    };
    // Firma válida pero imagen corrupta / no decodificable
    img.onerror = () => this.rejectVoucher('format');
    img.src = dataUrl;
  }

  private acceptVoucher(file: File, dataUrl: string, isPdf: boolean): void {
    this.filesArray.push({
      name: file.name,
      file,
      url: dataUrl,
      isPdf
    });

    this.fileName = file.name;
    this.errorTranfer = false;
    this.calculateLeftTotal();
  }

  private rejectVoucher(reason: 'size' | 'format' | 'dimension'): void {
    this.errorTranfer = true;
    this.errorImageSize = reason === 'size';
    this.errorImageFormat = reason === 'format';
    this.errorImageDimension = reason === 'dimension';
    this.calculateLeftTotal();
  }

  /** Tipo real del archivo según su firma (magic bytes); null si no es un formato admitido */
  private detectVoucherType(bytes: Uint8Array): string | null {
    const startsWith = (signature: number[]) =>
      bytes.length >= signature.length && signature.every((byte, i) => bytes[i] === byte);

    if (startsWith([0xFF, 0xD8, 0xFF])) {
      return 'image/jpeg';
    }
    if (startsWith([0x89, 0x50, 0x4E, 0x47, 0x0D, 0x0A, 0x1A, 0x0A])) {
      return 'image/png';
    }
    if (startsWith([0x25, 0x50, 0x44, 0x46, 0x2D])) { // %PDF-
      return 'application/pdf';
    }
    return null;
  }

  /**
   * Busca en el PDF marcadores de contenido activo. Heurístico: no descomprime streams,
   * por eso el backend tiene que validar de nuevo.
   */
  private pdfHasActiveContent(bytes: Uint8Array): boolean {
    let text = '';
    const chunkSize = 0x8000;
    for (let i = 0; i < bytes.length; i += chunkSize) {
      text += String.fromCharCode.apply(null, Array.from(bytes.subarray(i, i + chunkSize)));
    }

    const activeContent = /\/(JavaScript|JS|Launch|EmbeddedFiles?|OpenAction|AA|RichMedia|XFA|SubmitForm|ImportData)\b/;
    return activeContent.test(text);
  }

  private bytesToBase64(bytes: Uint8Array): string {
    let binary = '';
    const chunkSize = 0x8000;
    for (let i = 0; i < bytes.length; i += chunkSize) {
      binary += String.fromCharCode.apply(null, Array.from(bytes.subarray(i, i + chunkSize)));
    }
    return btoa(binary);
  }


  pointsChange() {
    this.revertFeeIfApplied();
    this.isPointsSelected=!this.isPointsSelected
    if (!this.isPointsSelected) {
      if (this.openMethodId === 1) {
        this.openMethodId = 0;
      }
      if(this.paymentMethodsArr.length > 0) {
        const objAmountPoints = this.paymentMethodsArr.find(c => c.id === 1);

        if(objAmountPoints) {
          this.amountPoints = objAmountPoints.amount;
        }
      } else {
        this.amountPoints = 0;
      }
    } else {
      this.openMethodId = 1;
      if(this.paymentMethodsArr.length > 0) {
        const objAmountPoints = this.paymentMethodsArr.find(c => c.id === 1);
        if(objAmountPoints) {
          this.amountPoints = objAmountPoints.amount;
        }
      }
      setTimeout(() => {
        if(this.creditBlickoinsActives > 0) {
          this.inputCredits.focus;
        }
      }, 500);
    }
    this.calculateLeftTotal();
  }

  creditChange() {
    this.revertFeeIfApplied();
    this.isDepositSelected=!this.isDepositSelected
    if (!this.isDepositSelected) {
      if (this.openMethodId === 3) {
        this.openMethodId = 0;
      }
      if(this.paymentMethodsArr.length > 0) {
        const objAmountDeposit = this.paymentMethodsArr.find(c => c.id === 3);
        if(objAmountDeposit) {
          this.amountDeposit = objAmountDeposit.amount;
        }
      } else {
        this.amountDeposit = 0;
      }
    } else {
      this.openMethodId = 3;
      if(this.paymentMethodsArr.length > 0) {
        const objAmountDeposit = this.paymentMethodsArr.find(c => c.id === 3);
        if(objAmountDeposit) {
          this.amountDeposit = objAmountDeposit.amount;
        }
      }
    }
    this.calculateLeftTotal();
  }

  tranferChange() {
    this.revertFeeIfApplied();
    this.isTranferSelected=!this.isTranferSelected
    if (!this.isTranferSelected) {
      if (this.openMethodId === 4) {
        this.openMethodId = 0;
      }
      if(this.paymentMethodsArr.length > 0) {
        const objAmountTransfer = this.paymentMethodsArr.find(c => c.id === 4);
        if(objAmountTransfer) {
          this.amountTranfer = objAmountTransfer.amount;
        }
      } else {
        this.amountTranfer = 0;
      }
      // this.fileName = null;
    } else {
      this.openMethodId = 4;
      if(this.paymentMethodsArr.length > 0) {
        const objAmountTransfer = this.paymentMethodsArr.find(c => c.id === 4);
        if(objAmountTransfer) {
          this.amountTranfer = objAmountTransfer.amount;
        }
      }
      setTimeout(() => {
        this.inputTranfer.focus;
      }, 500);
    }
    this.calculateLeftTotal();
  }

  cardChange() {
    this.revertFeeIfApplied();
    this.isCardSelected=!this.isCardSelected
    if (!this.isCardSelected) {
      if (this.openMethodId === 2) {
        this.openMethodId = 0;
      }
      if(this.paymentMethodsArr.length > 0) {
        const objAmountCard = this.paymentMethodsArr.find(c => c.id === 2);
        if(objAmountCard) {
          this.amountCard = objAmountCard.amount;
        }
      } else {
        this.amountCard = 0;
      }

    } else {
      this.openMethodId = 2;
      if(this.paymentMethodsArr.length > 0) {
        const objAmountCard = this.paymentMethodsArr.find(c => c.id === 2);
        if(objAmountCard) {
          this.amountCard = objAmountCard.amount;
          if(this.amountCard === this.amountCreditCardPayPartial) {
            this.amountCard = null;
          }
        }
      }
      setTimeout(() => {
        this.inputCard.focus;
      }, 500);
    }
    this.calculateLeftTotal();
  }

  pointsCreditChange() {
    this.isPointsSelected = false;
    this.isDepositSelected = false;
    this.isTranferSelected = false;
    this.isCardSelected = false;
    this.isCreditSelected=!this.isCreditSelected
    if (!this.isPointsSelected) {
      this.amountPoints = 0;
      this.calculateLeftTotal();
    } else {
      setTimeout(() => {
        this.inputPoints.focus;
      }, 500);
    }
  }

  payComplete(model) {

    if (this.leftTotal == 0) {
      switch (model) {
        case 1:
          this.amountPoints = 0;
          // this.amountDeposit = 0;
          // this.amountTranfer = 0;
          // this.amountCard = 0;
          break;

        case 2:
          this.amountDeposit = 0;
          // this.amountPoints = 0;
          // this.amountTranfer = 0;
          // this.amountCard = 0;
          break;

        case 3:
          this.amountTranfer = 0;
          // this.amountPoints = 0;
          // this.amountDeposit = 0;
          // this.amountCard = 0;

          break;

        case 4:
          this.amountCard = 0;
          // this.amountPoints = 0;
          // this.amountDeposit = 0;
          // this.amountTranfer = 0;
          break;

        default:
          break;
      }
    } else {
      switch (model) {
        case 1:
          this.amountPoints = this.leftTotal;
          // this.amountDeposit = 0;
          // this.amountTranfer = 0;
          // this.amountCard = 0;
          break;

        case 2:
          this.amountDeposit = this.leftTotal;
          // this.amountPoints = 0;
          // this.amountTranfer = 0;
          // this.amountCard = 0;
          break;

        case 3:
          this.amountTranfer = this.leftTotal;
          // this.amountPoints = 0;
          // this.amountDeposit = 0;
          // this.amountCard = 0;

          break;

        case 4:
          this.amountCard = this.leftTotal;
          // this.amountPoints = 0;
          // this.amountDeposit = 0;
          // this.amountTranfer = 0;
          break;

        default:
          break;
      }
    }
    this.calculateLeftTotal();
  }

  removeIMG(i) {
    this.filesArray.splice(i, 1);
  }

  verifyPaymentMethod(id: any) {

      // eslint-disable-next-line max-len
      const result = this.itineraryService.paymentConditions.payment_methods_conditions.find(element => parseInt(element.payment_methods_id) == id);
   //  console.log("result", result);
    if (result) {
      return true;
    } else {
      /* this.agentsService.agencyPaymentConditionByID(this.agency.pay_mode).subscribe(
        (response: any) => {
          this.agentsService.paymentConditions = response.payment_methods_conditions;
          console.log("this.agentsService.paymentConditions", this.agentsService.paymentConditions);
        }
        ); */
        return false;
      }

  }

  selectModePay() {
   //this.initConfig();
   this.isSelectModePay = true;
  }

  cancelPayPaypal() {
    this.isSelectModePay = false;
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  public savePaymetCreditsCards(payload: any): void {
    this._restService.doPost('app', 'paymentCreditCards/create', payload).subscribe(
      (response: any) => {
        if (response.success) {

           this.feeVisible = false;
           this.paymentCardWithApplyFeeEmitter.emit(false);
           this.getPaymentCreditCards(this.filter);
        } else {
          console.log("error al rgistrar el pago con tarjeta d credito");
        }
      },
      error=>{
        console.log("error");
      }
    )

  }


  public getPaymentCreditCards(filter: any): void {

      const url = 'paymentCreditCards/listPending?' + filter;
      this._restService.doGet('app', url).subscribe((response: any) => {
        if (response.data.data.length > 0) {
          this.totalPaymentCreditCards = 0;
          this.paymentCreditCards = response.data.data;
          // Dividir la cadena en dos partes en función del signo igual (=)
          const parts = this.filter.split('=');

          // Tomar solo la primera parte (antes del signo igual)
          const filter = parts[1];
          this.paymentCreditCards = this.paymentCreditCards.filter(c => c.itinerary_id === Number(filter));
          const nullPaymentCard = this.paymentCreditCards.filter(c => c.payment_masters_id === null);
          if(this.creditCardPayPartial) {
            this.totalPaymentCreditCards = this.amountSumCreditCardPending(nullPaymentCard);
            if(this.leftTotal === 0) {
              this.totalPayCreditCard = true;
            }
          }
          if(this.creditCardPending) {
            this.totalPaymentCreditCards = this.amountSumCreditCardPending(nullPaymentCard);

          }
          if(!this.creditCardPending && !this.creditCardPayPartial && nullPaymentCard.length > 0) {
            this.totalPaymentCreditCards = this.amountSumCreditCardPending(nullPaymentCard);

          }
        }
        if (this.totalPaymentCreditCards > 0 && this.paymentCreditCards.length > 0) {
            this.isCardSelected = true;
            this.openMethodId = 2;
            this.calculateLeftTotal();
        }
      }, err => {
        console.log('No existe informacion, Condición de Pagos!');
      });
  }


  private getValidatedAmount(): string {
  let amount: number;
  if (this.amountCard > 0) {
    amount = this.amountCard + Number(this.leftTotal || 0);
  } else {
    amount = Number(this.leftTotal || 0);
  }

  // Redondear y validar
  amount = Math.round(amount * 100) / 100;
  if (isNaN(amount) || amount <= 0) {
    return '0.00';
  }

  return amount.toFixed(2);
}


  private initConfig(): void {
    let registration_gateway: boolean;
    if(!this.creditCardPending && !this.creditCardPayPartial) {
      registration_gateway = this.itineraryService.paymentConditions.registration_gateway == 0 ? false : true;
    } else {
      registration_gateway = false;
    }

    const amountString = this.getValidatedAmount();
    const amountNumber = parseFloat(amountString);

    this.payPalConfig = {
      currency: 'USD',
      clientId: setting.clientIdPaypal,
      createOrderOnClient: (data) => <ICreateOrderRequest>{
        intent: 'CAPTURE',
        purchase_units: [{
          amount: {
            currency_code: 'USD',
            value: this.amountCard,
            breakdown: {
              item_total: {
                currency_code: 'USD',
                value: this.amountCard,
              }
            }
          },
          items: [{
            name: 'Booking Subscription',
            quantity: '1',
            category: 'DIGITAL_GOODS',
            unit_amount: {
              currency_code: 'USD',
              value: this.amountCard,
            },
          }]
        }]
      },
      advanced: {
        commit: 'true',
        extraQueryParams: [ { name: 'disable-funding', value: 'credit,card'} ]
      },
      style: {
        layout: 'vertical',  // vertical 2 botones   // horizontal 1 boton
        // layout:  registration_gateway ?  'vertical' : 'horizontal',  // vertical 2 botones   // horizontal 1 boton
        color:   'gold',
        shape:   'pill',
        label:   'paypal',
        height: 40,
        size: 'small',
        tagline: false,

      },

      onApprove: (data, actions) => {
        actions.order.get().then(details => {
          /// enviar a guardar el pago
          let index = 0;

          if(this.creditCardPayPartial) {
            const items: any = this.creditCardDataPending.filter(c => c.payment_masters_id === null);
            if(items[0].details.length > 1) {

              items.forEach(element => {
                const newItem: any = [{
                    product_id: Number(element.details[0].uid),
                    feePayment: this.applyFee,
                    category_id: element.details[0].category_id
                }];

                // Verifica si el elemento ya existe en this.payloadDetails
                const exists = this.payloadDetails.some(item => item.product_id === newItem.product_id && item.category_id === newItem.category_id);

                // Si el elemento no existe en this.payloadDetails, lo agrega
                if (!exists) {
                    this.payloadDetails.push(newItem);
                }
            });


              } else {
                this.payloadDetails = [{
                  product_id: Number(items[0].details[0].uid),
                  feePayment: this.applyFee,
                  category_id: items[0].details[0].category_id
                 }]
              }
          } else {
            this.items.forEach(element => {

               const amountBase = this.currencies.find(c => c.code === element.currency);
               const netPriceBookingBase = this.amountCard / amountBase.rate;
               const amount_payment = netPriceBookingBase * this.currencyAgency.rate;

             // this.payloadDetails.push(element.id);
             this.payloadDetails[index] = {
                 product_id: element.id,
                 feePayment: this.applyFee,
                 category_id: element.category_id,
                 currency_payment: this.currencyAgency?.code,
                 amount_payment: amount_payment,
                 amount_historic_payment: {
                 exchange_rate: parseFloat(Number(this.currencyAgency.rate).toFixed(2)),
                  converted_amounts: {
                    fee: parseFloat(Number(element.fee * this.currencyAgency.rate).toFixed(2)),
                    netPriceAgent: parseFloat(Number(element.netPriceAgent * this.currencyAgency.rate).toFixed(2)),
                    netPriceBooking: parseFloat(Number(element.netPriceBooking * this.currencyAgency.rate).toFixed(2)),
                    taxPrice: parseFloat(Number(element.taxNightsPriceTotal * this.currencyAgency.rate).toFixed(2)),
                    netPriceBookingFreeTax: element.taxNightsPriceTotal === 0 ? parseFloat(Number(element.netPriceBooking * this.currencyAgency.rate).toFixed(2)) : parseFloat(Number(element.netPriceBookingFreeTax * this.currencyAgency.rate).toFixed(2)),
                    netPriceProvider: parseFloat(Number(element.profility.netPriceProvider * this.currencyAgency.rate).toFixed(2)),
                    netPriceCategory: parseFloat(Number(element.profility.netPriceCategory * this.currencyAgency.rate).toFixed(2)),
                    extras: this.getServiceExtrasConverted(element),
                }
              }}
                index = index + 1;
            });
          }



          this.payload = {
            payment_masters_id: '',
            payment_id: details.id,
            payer_id: details.payer.payer_id,
            payer_name: details.payer.name.given_name + ' ' + details.payer.name.surname,
            payer_email: details.payer.email_address,
            amount: details.purchase_units[0].amount.value,
            products:  this.payloadDetails,
            status: details.status,
            currency: this.currencyItinerary,
            agent_id: this.userService._agentID,
            agency_id: this.userService._agencyID
           };

          if(this.creditCardPayPartial) {
            this.payload.itinerary_id = this.creditCardDataPending[0].itinerary_id;
          } else {
            this.payload.itinerary_id = this.items[0].itinerary_id;
          }

          this.amountCard = 0; // recinicar campo de tdc
          this.savePaymetCreditsCards(this.payload);

          // this.proccessPaypalPayment();

        });
      },
      onClientAuthorization: (data) => {
        this.onApprove = true;
        this.isSelectModePay = false;
        //this.showSuccess = true;
      },
      onCancel: (data, actions) => {
        //this.showCancel = true;
      },
      onError: err => {
        console.error('Error en pago con PayPal:', err);
        //this.showError = true;
      },
      onClick: (data, actions) => {
        //this.resetStatus();
      }
    };
  }


  parseDate(date){
    const fecha = date.split(' ')[0].split('-')
    return `${fecha[2]}/${fecha[1]}/${fecha[0]}`
  }

  parseHour(date) {
    return date.split('T')[1].split(':').slice(0, 2).join(':'); // "19:42"
  }

  payTotal(methods: number) {
    if (methods === 1) {
        if(this.amountPoints) {
          this.amountPoints = this.amountPoints + Number(this.leftTotal);
          this.amountPoints = this.roundToTwoDecimals(this.amountPoints);
        } else {
          this.amountPoints = this.leftTotal;
          this.amountPoints = this.roundToTwoDecimals(this.amountPoints);
        }
        this.calculateLeftTotal();
    } else if (methods === 2) {
        if(this.amountDeposit > 0) {
          this.amountDeposit = this.amountDeposit + Number(this.leftTotal);
           this.amountDeposit = this.roundToTwoDecimals(this.amountDeposit);
        } else {
          this.amountDeposit = this.leftTotal;
           this.amountDeposit = this.roundToTwoDecimals(this.amountDeposit);
        }
        this.calculateLeftTotal();
    } else if (methods === 3) {
        if(this.amountTranfer > 0) {
          this.amountTranfer = this.amountTranfer + Number(this.leftTotal);
           this.amountTranfer = this.roundToTwoDecimals(this.amountTranfer);

        } else {
          this.amountTranfer = this.leftTotal;
          this.amountTranfer = this.roundToTwoDecimals(this.amountTranfer);
        }
        this.calculateLeftTotal();
    } else if (methods === 4) {
      if(this.amountCard > 0) {
        this.amountCard = this.amountCard + Number(this.leftTotal);
        this.amountCard = this.roundToTwoDecimals(this.amountCard);
      } else {
        this.amountCard = this.leftTotal; // en este ingresa
        this.amountCard = this.roundToTwoDecimals(this.amountCard);
      }
        this.calculateLeftTotal();
    }
}

roundToTwoDecimals(value: number): number {
    return Math.round(value * 100) / 100;
}


paymentMethodSelected(paymentMethodsId: number) {
  switch(paymentMethodsId) {
    case 1 :
      break;
    case 2 :
      break;
    case 3 :
      break;
    case 4 :
      break;
  }
}

onAmountChange(newValue: number) {
  // Manejar el cambio del modelo y asegurarse de que no exceda totalPrice
  if (newValue > this.totalPrice) {
    this.amountDeposit = this.totalPrice;
  }
}

filesArrayTransfer(): boolean {
  if(this.filesArray.length >= 3) {
    return true;
  }
 return false;
}

preventScroll(event: WheelEvent): void {
  event.preventDefault();
}

addFee(): void {
  if (!this.applyFee) {
    this.applyFee = true;
    this.applyFeeEmitter.emit(true);
    this.paymentCardWithApplyFeeEmitter.emit(true);
    this.amountCard = parseFloat((this.amountCard + this.fee).toFixed(2));
    // totalPrice se ajusta acá mismo (ya no llega recalculado del padre vía Input,
    // ver totalPriceInput) para que amountCard no quede por encima del máximo permitido.
    this.totalPrice = parseFloat((this.totalPrice + this.fee).toFixed(2));
    // Sincroniza el TOTAL que muestra el padre (totalPaymentPrice), que solo se
    // actualiza escuchando este evento.
    this.totalPriceEmit.emit(this.totalPrice);
    this.emitFeePayment.emit(this.fee);
  } else {
    this.revertFeeIfApplied();
  }
}

/** El fee de los productos (rentabilidad del agente) se puede sumar al pago con tarjeta. */
showProductFee(): boolean {
  return this.fee > 0 && !this.totalPayCreditCard && this.feeVisible;
}

/** Tarifa neta sin el fee: totalPrice lo incluye cuando se sumó (ver addFee). */
getCardNetPrice(): number {
  const net = this.applyFee ? Number(this.totalPrice) - Number(this.fee) : Number(this.totalPrice);
  return Math.round(net * 100) / 100;
}

/**
 * Porcentaje del fee de productos tal como lo carga el agente. Ese fee es un margen sobre el
 * precio de venta (netPriceAgent = neto / (1 − %/100), ver item-status), así que el % es
 * fee / (neto + fee) y no fee / neto (con 3.5% daría 3.63%).
 */
getProductFeePercentage(): number {
  const net = this.getCardNetPrice();
  const fee = Number(this.fee) || 0;
  return net + fee > 0 ? (fee / (net + fee)) * 100 : 0;
}

verifyFeeAmountCard(): void {

  if(this.applyFee) {
    if(this.amountCard < this.fee) {
      this.notificationService.info('El valor ingresado debe ser igual o mayor al fee');
    }
  }
}

changeCurrencyPayment(event: any): void {
  // Si el fee estaba sumado, hay que sacarlo de totalPrice antes de convertir de
  // moneda: si no, queda "pegado" ahí, la conversión lo arrastra y al volver a
  // aplicarlo (o al cambiar de moneda otra vez) el total queda inflado.
  this.revertFeeIfApplied();

  this.filesArray = [];
  this.fileName = null;
  this.amountPoints = null;
  this.amountDeposit = null;
  this.amountTranfer = null;
  this.amountCard = null;
  this.amountCredit = null;

  // Se deseleccionan todos los métodos de pago para evitar que quede un método
  // con un error "congelado" (por no reevaluarse al ser el monto null) bloqueando
  // el botón Continuar del componente padre tras el cambio de moneda.
  this.isPointsSelected = false;
  this.isDepositSelected = false;
  this.isTranferSelected = false;
  this.isCardSelected = false;
  this.isCreditSelected = false;
  this.openMethodId = 0;

  this.errorPoints = false;
  this.errorDeposit = false;
  this.errorTranfer = true;
  this.errorCard = true;
  this.errorCredit = false;
  this.errorOverpay = false;

  this.paymentMethods = [];

  // Las plataformas de tarjeta dependen de la moneda (USD: Square/PayPal, ARS: Mercado Pago)
  this.resetMercadoPagoForm();
  this.selectedMethodPlatformPayment = '';

  if(event === 'USD') {
    this.totalPrice = parseFloat((Number(this.totalPrice) / Number(this.currencyAgency?.rate)).toFixed(2));
  } else {
     this.totalPrice = parseFloat((Number(this.totalPrice) * Number(this.currencyAgency?.rate)).toFixed(2));
  }
  this.currencyPayment = event;
  this.currencyPaymentEmmiter.emit(event);
  this.totalPriceEmit.emit(this.totalPrice);
  // Recalcula y emite leaveTotal para sincronizar al componente padre (verifyNext()
  // usa el leaveTotal del padre, que sin esto quedaba desactualizado tras el cambio de moneda).
  this.calculateLeftTotal();
}

     /**
   * Bloquea la entrada de caracteres no deseados (`e`, `E`, `+`, `-`) en campos numéricos.
   * @param event El evento de teclado.
   */
blockInvalidKeys(event: KeyboardEvent, input?: string) {
    const key = event.key;

    switch (input) {
        case 'name':
            // Permitir teclas especiales: Backspace, Delete, Tab, Escape, Enter, y las flechas
            if (
              [
                'Backspace',
                'Delete',
                'Tab',
                'Escape',
                'Enter',
                'ArrowLeft',
                'ArrowRight',
              ].includes(key)
            ) {
              return; // Permitir estas teclas
            }

            // Bloquear caracteres que no coincidan con letras, acentos, ñ o espacios
            if (!/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]$/.test(key)) {
              event.preventDefault();
            }
            break;

        case 'number':
            if (['e', 'E', '+', '-', '..', ',,'].includes(key)) {
                event.preventDefault();
              }
            break;
    }
  }

  getTitleMethods(paymentMethods: any): string {

    switch(paymentMethods.payment_methods_id) {
      case 1: return 'POR BLICKOINS';
      case 2: return 'POR DEPÓSITO DE GARANTÍA';
      case 3: return 'POR TRANSFERENCIA';
      case 4: return 'POR TARJETA';
      default: return 'N/A';
    }
    return ''
  }



  private checkAndInitializeSquare() {
    // Solo inicializar si:
    // 1. Square está seleccionado
    // 2. El contenedor existe en el DOM
    // 3. Aún no hemos intentado inicializar
    // 4. Square no está ya inicializado

    if (this.selectedMethodPlatformPayment === 'square' &&
        !this.squareInitializationAttempted &&
        !this.squareInitialized) {

      const containerExists = !!this.squareContainer;

      if (containerExists && this.squareContainer.nativeElement) {
        this.squareInitializationAttempted = true;
        this.initializeSquareForm();
      }
    }
  }

  async initializeSquareForm() {
    try {

      // 1. Inicializar SDK
      const initialized = await this.squareService.initializeSquare();

      if (!initialized) {
        return;
      }

      // 2. Asegurar que el contenedor esté visible
      if (this.squareContainer && this.squareContainer.nativeElement) {
        const container = this.squareContainer.nativeElement;

        // Forzar que sea visible
        container.style.display = 'block';
        container.style.visibility = 'visible';
        container.style.height = 'auto';

        // 3. Crear formulario
        const created = await this.squareService.createCard('square-card-container');

        if (created) {
          this.isSquareReady = true;
          this.squareInitialized = true;
        } else {
          console.error('❌ No se pudo crear formulario');
        }
      } else {
        console.error('❌ squareContainer no disponible');
      }

    } catch (error) {
      console.error('❌ Error en initializeSquareForm:', error);
      this.squareInitializationAttempted = false; // Permitir reintento
    }
  }

  async onPaymentMethodSelected(method: string) {
    if (method !== 'mercadopago') {
      this.resetMercadoPagoForm();
    }

    // Resetear estados de inicialización
    this.selectedMethodPlatformPayment = method;
    this.squareInitializationAttempted = false;
    this.squareInitialized = false;
    this.isSquareReady = false;

    // Forzar detección de cambios
    this.cdr.detectChanges();

    // El fee bancario de tarjeta depende de la plataforma: re-emitir al padre
    this.calculateLeftTotal();

    if (method === 'square') {
      // Pequeña pausa para que Angular renderice
      await new Promise(resolve => setTimeout(resolve, 0));

      // Ahora checkAndInitializeSquare se llamará automáticamente
      // en ngAfterViewChecked cuando el contenedor esté listo
    }

  }

  shouldShowSquareContainer(): boolean {
  const result = this.amountCard <= this.totalPrice &&
                 this.amountCard >= 0 &&
                 !this.totalPayCreditCard;
  return result;
}

// ─── Mercado Pago (tarjeta en ARS) ───

/** Importe que cobra Mercado Pago ahora: lo que se abona con tarjeta + fee de la plataforma */
getMercadoPagoChargeAmount(): number {
  const amount = Number(this.amountCard) || 0;
  return Math.round((amount + this.getMethodSurcharge(2, amount)) * 100) / 100;
}

/** El formulario se puede mostrar: hay importe a cobrar y no supera el total */
canPayWithMercadoPago(): boolean {
  return this.shouldShowSquareContainer() && Number(this.amountCard) > 0;
}

/**
 * Renderiza el formulario de Mercado Pago con el importe actual. Se agrupa (debounce) porque
 * calculateLeftTotal corre en cada tecla del importe y cada render recrea el formulario.
 */
private scheduleMercadoPagoRender(): void {
  if (this.selectedMethodPlatformPayment !== 'mercadopago') {
    return;
  }

  clearTimeout(this.mercadoPagoRenderTimeout);

  if (!this.canPayWithMercadoPago()) {
    this.resetMercadoPagoForm();
    return;
  }

  const amount = this.getMercadoPagoChargeAmount();
  if (amount === this.mercadoPagoRenderedAmount) {
    return;
  }

  this.mercadoPagoRenderTimeout = setTimeout(() => this.renderMercadoPagoForm(amount), 600);
}

private async renderMercadoPagoForm(amount: number): Promise<void> {
  this.isMercadoPagoReady = false;
  this.mercadoPagoRenderedAmount = amount;
  this.cdr.detectChanges();

  const initialized = await this.mercadoPagoStrategy.initialize();
  // El usuario pudo cambiar de plataforma o de importe mientras cargaba el SDK
  if (!initialized || this.selectedMethodPlatformPayment !== 'mercadopago' || this.mercadoPagoRenderedAmount !== amount) {
    if (!initialized) {
      this.mercadoPagoRenderedAmount = null;
      this.notificationService.error('No se pudo cargar el formulario de Mercado Pago.');
    }
    return;
  }

  const rendered = await this.mercadoPagoStrategy.renderPaymentForm(this.mercadoPagoContainerId, {
    amount,
    payerEmail: this.userService._email
  });

  if (this.mercadoPagoRenderedAmount === amount) {
    this.isMercadoPagoReady = rendered;
    if (!rendered) {
      this.mercadoPagoRenderedAmount = null;
    }
    this.cdr.detectChanges();
  }
}

private resetMercadoPagoForm(): void {
  clearTimeout(this.mercadoPagoRenderTimeout);
  this.mercadoPagoRenderedAmount = null;
  this.isMercadoPagoReady = false;
  this.mercadoPagoService.destroyCardForm();
}

async processMercadoPagoPayment(): Promise<void> {
  if (this.isProcessing || !this.isMercadoPagoReady) {
    return;
  }
  this.isProcessing = true;

  try {
    const result = await this.mercadoPagoStrategy.processPayment(this.amountCard, this.buildMetadata());

    if (result.success) {
      this.notificationService.success(result.message || 'Pago aprobado');
      this.handleSuccessPaymentCreditCard(result);
      // El token es de un solo uso: limpiar el importe y el formulario para un nuevo cobro
      this.amountCard = 0;
      this.resetMercadoPagoForm();
      this.calculateLeftTotal();
    } else {
      this.notificationService.error(result.error || result.message || 'No se pudo procesar el pago con Mercado Pago.');
    }
  } catch (error) {
    console.error('Error en pago con Mercado Pago:', error);
    this.notificationService.error('Error inesperado al procesar el pago con Mercado Pago.');
  } finally {
    this.isProcessing = false;
  }
}


async proccessPaypalPayment() {
   this.isProcessing = true;

   try {
    const result = await this.paypalStrategy.processPayment(
        this.amountCard,
        this.buildMetadata()
      );

       if (result.success) {

        this.handleSuccessPaymentCreditCard(result);

       }
   } catch (error) {
      console.error('Error:', error);
      alert('Error inesperado');
    } finally {
      this.isProcessing = false;
    }

}

async processSquarePayment() {
    this.isProcessing = true;

    try {
      // DELEGAR todo a la estrategia
      const result = await this.squareStrategy.processPayment(
        this.amountCard,
        this.buildMetadata()
      );

      if (result.success) {
        this.handleSuccessPaymentCreditCard(result);
        // Manejar éxito
      } else {
        alert('Error: ' + result.error);
      }

    } catch (error) {
      console.error('Error:', error);
      alert('Error inesperado');
    } finally {
      this.isProcessing = false;
    }
  }

  // Guest: paga y reserva en un solo paso. A diferencia de processSquarePayment()
  // (que registra el pago sobre productos ya reservados por el agente vía
  // paymentCreditCards/create + paymentMasters/create), acá no existe reserva
  // previa: pay-reservate hace ambas cosas en el backend. Si falla, se avisa
  // pero se sigue igual — quien llama (modal-post-booking → body-reservation)
  // avanza sin mirar el resultado, tal como confirmationRedirect() en el flujo
  // de agente.
  async processSquarePaymentGuest(): Promise<void> {
    this.isProcessing = true;
    try {
      const nonce = await this.squareService.tokenizeCard();
      if (!nonce) {
        this.notificationService.warning('No se pudo procesar la tarjeta, pero continuamos con tu reserva');
      } else {
        const payload: any = {};
        payload.product_ids = this.itineraryItems.map((item: any) => item.id);
        payload.amount = this.amountCard;
        payload.currency = this.currencyPayment;
        // payload.amount = this.itineraryItems.reduce((sum, item) => sum + (item.netPriceAgent|| 0), 0);
        // payload.currency = 'USD';
        payload.client_id = this.userService.clientIdFusion;
        payload.nonce = nonce;
        try {
          await this._restService.doPost('app', 'paymentMasters/pay-reservate', payload).toPromise();
          this.onApprove = true;
        } catch (error) {
          console.log('Error en paymentMasters/pay-reservate: ', error);
          this.notificationService.warning('Hubo un problema al procesar el pago, pero continuamos con tu reserva');
        }
      }
    } catch (error) {
      console.log('Error tokenizando tarjeta (guest): ', error);
      this.notificationService.warning('Hubo un problema al procesar el pago, pero continuamos con tu reserva');
    } finally {
      this.isProcessing = false;
      this.guestPaymentDone.emit();
    }
  }

  private handleSuccessPaymentCreditCard(result: PaymentResult) {


    // Actualizar UI
    this.feeVisible = false;
    this.paymentCardWithApplyFeeEmitter.emit(false);

    // Refrescar datos
    this.getPaymentCreditCards(this.filter);

  }

   private buildMetadata() {
    // Extrae esta lógica del componente
    return {
      agent_id: this.userService._agentID,
      agency_id: this.userService._agencyID,
      client_id: this.userService.clientIdFusion,
      itinerary_id: this.items[0].itinerary_id,
      currency: this.currencyPayment,
      amount_payment: this.amountCard,
      total_amount: this.amountCard,
      payloadDetails: this.getItemsDetailsCreditCard(),
      creditCardPayPartial: this.creditCardPayPartial,
      creditCardDataPending: this.creditCardDataPending,
      dataPaymentCreditCard: {
        id: this.getRandomUniqueId(),
        payer_id: this.userService._agentID,
        payer_name: this.userService._name,
        payer_email: this.userService._email,

      }
    };
  }

  private getRandomUniqueId(){
    return Math.floor(Math.random() * 20000000000000) + Date.now();
  }

  private getItemsDetailsCreditCard(): any[] {

    let paymentDetails: any[] = [];
    let index = 0;

     this.items.forEach(element => {

               // amountCard viene en la moneda de pago: en USD se convierte a la de la agencia;
               // en la moneda de la agencia (ARS con Mercado Pago) ya está convertido.
               const amountBase = this.currencies.find(c => c.code === element.currency);
               const netPriceBookingBase = this.amountCard / amountBase.rate;
               const amount_payment = this.currencyPayment === 'USD'
                 ? netPriceBookingBase * this.currencyAgency.rate
                 : Number(this.amountCard);

             // this.payloadDetails.push(element.id);
             paymentDetails[index] = {
                 id: element.id,
                 product_id: element.id,
                 feePayment: this.applyFee,
                 category_id: element.category_id,
                 currency_payment: this.currencyAgency?.code,
                 amount_payment: parseFloat(Number(amount_payment).toFixed(2)),
                 amount_historic_payment: {
                 exchange_rate: parseFloat(Number(this.currencyAgency.rate).toFixed(2)),
                  converted_amounts: {
                    fee: parseFloat(Number(element.fee * this.currencyAgency.rate).toFixed(2)),
                    netPriceAgent: parseFloat(Number(element.netPriceAgent * this.currencyAgency.rate).toFixed(2)),
                    netPriceBooking: parseFloat(Number(element.netPriceBooking * this.currencyAgency.rate).toFixed(2)),
                    taxPrice: parseFloat(Number(element.taxNightsPriceTotal * this.currencyAgency.rate).toFixed(2)),
                    netPriceBookingFreeTax: element.taxNightsPriceTotal === 0 ? parseFloat(Number(element.netPriceBooking * this.currencyAgency.rate).toFixed(2)) : parseFloat(Number(element.netPriceBookingFreeTax * this.currencyAgency.rate).toFixed(2)),
                    netPriceProvider: parseFloat(Number(element.profility.netPriceProvider * this.currencyAgency.rate).toFixed(2)),
                    netPriceCategory: parseFloat(Number(element.profility.netPriceCategory * this.currencyAgency.rate).toFixed(2)),
                    extras: this.getServiceExtrasConverted(element),
                }
              }}
                index = index + 1;
            });


      return paymentDetails;
  }

getServiceExtrasConverted(product: any): any[] {
  // Validar que exista serviceExtra
  // Validar que currencyAgency existe
  if (!this.currencyAgency || !this.currencyAgency.rate) {
    console.error('currencyAgency o rate no definido');
    return product.serviceExtra; // Retorna sin conversión
  }

       let addonsIncludedPaymentOffice: any[] = [];

       if(product?.addonsIncluded && product?.addonsIncluded.length > 0) {
        addonsIncludedPaymentOffice = product?.addonsIncluded.filter(c => c.PaymentOffice === false || c.paymentOffice === false);
       } else if (product?.amenitiesIncluded && product?.amenitiesIncluded.length > 0) {
        addonsIncludedPaymentOffice = product?.amenitiesIncluded.filter(c => c.PaymentOffice === false || c.paymentOffice === false);
       } else {
          return [];
       }

      return addonsIncludedPaymentOffice.map((extra: any) => ({
        ...extra,
        priceAmountPayment: parseFloat(Number(this.getPriceAmountPaymentExtras(extra, product?.currency, product?.category_id)).toFixed(2)),
      }));
}

    getPriceAmountPaymentExtras(extra: any, currency: string, categoryId: number): number {
            if (!extra) {
              return 0;
            }

            const baseRate = this.currencies.find(c => c.code === currency)?.rate || 1;
            let priceExtra: number = 0;
            let priceProf: number = 0;

            switch(categoryId) {
              case 1: // Hotel
                priceProf =  ((extra?.price || 0) / baseRate) * this.currencyAgency.rate;
                break;
              case 2: // Rent a car
                priceProf =  ((extra?.totalNetPriceProf || 0) / baseRate) * this.currencyAgency.rate;
                break;
              case 6: // Tour
                priceProf =  ((extra?.totalPriceProf || 0) / baseRate) * this.currencyAgency.rate;
                break;
              case 8: // Traslado
                priceProf =  ((extra?.totalPrice || 0) / baseRate) * this.currencyAgency.rate;
                break;
              case 9: // Ticket
                priceProf =  ((extra?.totalPriceProf || 0) / baseRate) * this.currencyAgency.rate;
                break;
            }

            priceExtra = priceProf;

            return priceExtra;
}



}
